/** Leaving the portal for another site (a payment processor's hosted page). Its own module so tests
 * can stand in for it: a test browser can't really navigate away. */
export function leavePortal(url: string): void {
  window.location.assign(url);
}
